import React from "react";

import Container from "@mui/material/Container";
import { Button, Grid } from "@mui/material";
import Modal from "@mui/material/Modal";

import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";

import settings from "../../Images/settings.png";
import timer from "../../Images/timer.png";
import smallusdt from "../../Images/smallusdt.png";
import smallgsx from "../../Images/smallgsx.png";
import pluspink from "../../Images/pluspink.png";
import smallgsxusdt from "../../Images/smallgsxusdt.png";

import Navbar from "../Navbar/Index";
import Footer from "../Footer/Index";

import { Link } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Removeliquidity = () => {
  const [showResults, setShowResults] = React.useState(false);
  const percent = () => setShowResults(true);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openrec, setOpenrec] = React.useState(false);
  const handleOpenrec = () => setOpenrec(true);
  const handleCloserec = () => setOpenrec(false);

  const [openywr, setOpenywr] = React.useState(false);
  const handleOpenywr = () => setOpenywr(true);
  const handleCloseywr = () => setOpenywr(false);

  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Navbar />
      <Container>
        <div className="forheight">
          <Grid container justifyContent="center">
            <Grid xs={12} sm={11} md={6} className="py-5">
              <div className=" pt-sm-3 d-flex justify-content-center">
                <div className="Ray---Connectpage---Card ">
                  <div className="px-3 pt-3 Ray---Connect---Button---border">
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                      >
                        <Link
                          className="Ray---Connect--tab-btn1"
                          style={{ textDecoration: "none" }}
                          to="./swap"
                        >
                          <Tab label="Exchange" {...a11yProps(0)} />
                        </Link>
                        <Tab
                          label="Liquidity"
                          {...a11yProps(1)}
                          className="Ray---Connect--tab-btn"
                        />
                      </Tabs>
                    </Box>
                  </div>
                  <div className="px-3 pb-3">
                    <TabPanel value={value} index={1}>
                      <div className="Ray__Connect__Exchange pt-3">
                        Your Liquidity
                        <p className="Ray---connect---swap">
                          Remove Liquidity To Receive Tokens Back
                        </p>
                      </div>
                      <div className="Ray__Connect__Icons pt-3">
                        <img onClick={handleOpen} alt="" src={settings} />
                        <img
                          className="ml-2"
                          onClick={handleOpenrec}
                          alt=""
                          src={timer}
                        />
                      </div>
                      <div className="Ray---Connect---removeliquidity---box">
                        <div className="Ray---Connect---accordian">
                          <div className="p-3">
                            Amount
                            <label htmlFor="text"></label>
                            <input
                              className="mt-2 py-3 px-3 Ray---RemoveLiquidity---Text"
                              type="number"
                              name="phonenumber"
                              id="phonenumber"
                              placeholder="2.00%"
                            />
                            <Button
                              onClick={percent}
                              className="py-1 px-3 my-3 Rey---Removeliquidity---percentage---Button"
                            >
                              25%
                            </Button>
                            <Button className=" ml-2 py-1 px-3 my-3 Rey---Removeliquidity---percentage---Button">
                              50%
                            </Button>
                            <Button className="ml-2 py-1 px-3 my-3 Rey---Removeliquidity---percentage---Button">
                              75%
                            </Button>
                            <Button className="ml-2 py-1 px-3 my-3 Rey---Removeliquidity---percentage---Button">
                              Max
                            </Button>
                          </div>
                        </div>
                        <div className="p-3">
                          <div className="Rey---Head---card---ModalRecent1stbox">
                            <span style={{ fontSize: 18, color: "white" }}>
                              2
                            </span>
                            <span style={{ fontSize: 18, color: "white" }}>
                              {" "}
                              <img className="mr-3" alt="" src={smallgsx} />
                              GXS
                            </span>
                          </div>
                          <div className="Rey---Head---card---ModalRecent1stbox">
                            <span style={{ fontSize: 18, color: "white" }}>
                              20
                            </span>
                            <span style={{ fontSize: 18, color: "white" }}>
                              {" "}
                              <img className="mr-2" alt="" src={smallusdt} />
                              USDT
                            </span>
                          </div>
                          <div className="Rey---Head---card---ModalRecent1stbox">
                            <span
                              style={{ fontSize: 18, color: "white" }}
                            ></span>
                            <span
                              className="mt-3"
                              style={{
                                fontWeight: 400,
                                fontSize: 18,
                                color: "#997ABD",
                              }}
                            >
                              Recieved USDT
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="Rey---Head---card---ModalRecent1stbox">
                        <span
                          style={{ opacity: 0.5, fontSize: 12, color: "white" }}
                        >
                          Price
                        </span>
                        <span style={{ fontSize: 12, color: "white" }}>
                          {" "}
                          1 Gxs = 0.5 Usdt
                        </span>
                      </div>
                      <div className="Rey---Head---card---ModalRecent1stbox">
                        <span style={{ fontSize: 12, color: "white" }}></span>
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: 12,
                            color: "white",
                          }}
                        >
                          1 USDT = 2 GXS
                        </span>
                      </div>
                      <div className="twobuttonsremoveapprove">
                        <Button className="mt-3 px-5 Rey---Removeliquidity---ApproveRemove---Button">
                          Approve
                        </Button>

                        <Button
                          onClick={handleOpenywr}
                          className="mt-3 Rey---Removeliquidity---ApproveRemove---Button1"
                        >
                          Remove Liquidity
                        </Button>
                      </div>
                    </TabPanel>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        {/* Modal for settings starts here------------------------------------------ */}

        <Modal
          className="Modal"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Setting
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleClose(false)}
                >
                  X
                </button>
              </h4>
              <div
                className="Ray---Connect---Modal---fromto"
                style={{ color: "white" }}
              >
                <p>Slipage Tolerance?</p>

                <div className="Ray---settings---inputauto">
                  <Button className="Rey---settings---autobutton">auto</Button>

                  <label htmlFor="text"></label>
                  <input
                    className="Ray---Connect---Modal---Text"
                    type="text"
                    name="phonenumber"
                    id="phonenumber"
                    placeholder="2.00%"
                  />
                </div>
                <p className="mt-2 pb-2">Transaction Deadline?</p>

                <p className="Ray---Connect---Modal---TextTransaction"> 20</p>
                <p className="Ray---Connect---Modal---textmint">Minutes</p>
              </div>
            </div>
          </div>
        </Modal>
        {/* Modal for You will receive starts here------------------------------------------ */}

        <Modal
          className="Modal"
          open={openywr}
          onClose={handleCloseywr}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                You Will Receive
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleCloseywr(false)}
                >
                  X
                </button>
              </h4>
              <div className="Ray---Connect---removeliquidity---box p-3">
                <div className="Rey---Head---card---ModalRecent1stbox">
                  <span style={{ fontSize: 18, color: "white" }}>2</span>
                  <span style={{ fontSize: 18, color: "white" }}>
                    {" "}
                    <img className="mr-3" alt="" src={smallgsx} />
                    GXS
                  </span>
                </div>
                <div className="Rey---Head---card---ModalRecent1stbox">
                  <span style={{ fontSize: 18, color: "white" }}>
                    <img className="img-fluid" alt="" src={pluspink} />
                  </span>
                  <span style={{ fontSize: 18, color: "white" }}> </span>
                </div>
                <div className="Rey---Head---card---ModalRecent1stbox">
                  <span style={{ fontSize: 18, color: "white" }}>20</span>
                  <span style={{ fontSize: 18, color: "white" }}>
                    {" "}
                    <img className="mr-2" alt="" src={smallusdt} />
                    USDT
                  </span>
                </div>
              </div>
              <div className="Rey---Head---card---ModalRecent1stbox mt-5">
                <span style={{ opacity: 0.5, fontSize: 12, color: "white" }}>
                  LP GXS/USDT Burned
                </span>
                <span style={{ fontSize: 12, color: "white" }}>
                  {" "}
                  <img className="mr-2" alt="" src={smallgsxusdt} />
                  25
                </span>
              </div>
              <div className="Rey---Head---card---ModalRecent1stbox">
                <span
                  className="mt-1"
                  style={{ opacity: 0.5, fontSize: 12, color: "white" }}
                >
                  Price
                </span>
                <span className="mt-1" style={{ fontSize: 12, color: "white" }}>
                  {" "}
                  1 Gxs = 0.5 Usdt
                </span>
              </div>
              <div className="Rey---Head---card---ModalRecent1stbox">
                <span style={{ fontSize: 12, color: "white" }}></span>
                <span style={{ fontWeight: 400, fontSize: 12, color: "white" }}>
                  1 USDT = 2 GXS
                </span>
              </div>
              <Link style={{ textDecoration: "none" }} to="/">
                <Button className="mt-3 mb-1 Rey---Connect---SwapButton">
                  Confirm
                </Button>
              </Link>
            </div>
          </div>
        </Modal>
        {/* Modal for recent starts here -----------------------------------------*/}
        <Modal
          className=" Modal"
          open={openrec}
          onCloserec={handleCloserec}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            className="mt-5 pt-sm-5 d-flex justify-content-center"
            style={{ outline: "unset" }}
          >
            <div className="Ray---Connectpage---Card m-2 p-4">
              <h4
                style={{ color: "white" }}
                className="Rey---Head---card---ModalSettingHead"
              >
                Recent Transactions
                <button
                  className="L__Modal__CloseBtn"
                  onClick={() => handleCloserec(false)}
                >
                  X
                </button>
              </h4>

              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecentboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Send</h6>
                  <h6>-50 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span>Jan 10 To: 0X024...1E61</span>
                  <span> +50 Gxs</span>
                </div>
              </div>
              <div
                style={{ color: "white" }}
                className="Rey---Head---card---ModalRecent2ndboxcolor"
              >
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <h6>Recieved</h6>
                  <h6> +500 Gxs</h6>
                </div>
                <div
                  style={{ color: "white" }}
                  className="Rey---Head---card---ModalRecent1stbox"
                >
                  <span>Jan 10 To: 0X024...1E61</span>
                  <span> +500 Gxs</span>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Container>
      <Footer />
    </div>
  );
};
export default Removeliquidity;
